import React, { useEffect, useState } from "react";
import Header from "components/Pages/Header";
import HeaderDescription from "components/Pages/HeaderDescription";
import { PropertySlider } from "components/Pages/frontPage/PropertySlider";
import { MainFooter } from "components/MainFooter/MainFooter";
import Description from "components/Unit/Description";
import { ImgWrapper } from "components/ImgContainer/ImgWrapper";
import { _project } from "state/store.projects";
import { get, useGet } from "state/jotai";
import { BREAK_ } from "constants";
import RightLeftDescription from "./RightLeftDescription";
import { Box, useMediaQuery } from "@mui/material";
import { F_HOMEPAGE, F_UNITS } from "api/full_eido_api";
import { useTranslation } from "react-i18next";
import { _bootstrap } from "state/store.bootstrap";
import { useFetch } from "hooks/fetch/useFetch";
import Scrollbar from "react-scrollbars-custom";
import { useBreak } from "hooks/useBreak";
import RelatedUnits from "components/Gallery/MainPages/RelatedUnits";


export const Frontpage = () => {
  const isDesktop = useBreak("md_up");

  return (
    <>
      {isDesktop ? (
        <Scrollbar
          trackYProps={{
            renderer: (props) => {
              const { elementRef, ...restProps } = props;

              return (
                <span
                  {...restProps}
                  ref={elementRef}
                  className="trackY"
                  style={{ ...restProps.style }}
                />
              );
            },
          }}
        >
          <RenderComponent />
        </Scrollbar>
      ) : (
        <RenderComponent />
      )}
    </>
  );
};

const RenderComponent = () => {
  const {
    i18n: { language },
  } = useTranslation();
  const [homeData, setHomeData] = useState({});
 
    const rawUnits = get(_project, "unitsraw", "Units");
  const pid = useGet(_bootstrap).projectids?.[0] || null;
  const frontpageData = useFetch({ url: F_HOMEPAGE(pid, language) }).D;
 const isLargeDesktop = useMediaQuery("(min-width:1330px)");
   const [relatedUnits, setRelatedUnits] = useState([])

  
  // useEffect(() => {
  //   if (Object.keys(frontpageData || {}).length) {
  //     setHomeData(frontpageData);
  //   }
  // }, [frontpageData]);
// console.log(homeData,"sjjs")
useEffect(()=> {
    if(Object.keys(frontpageData || {}).length) {
      setHomeData(frontpageData)
     
      const ru = rawUnits.filter((u) => frontpageData?.UnitSlider?.unitIds?.includes(u.UnitID) && u?.Data?.UnitStatusID?.Value !== 30 && u?.Data?.UnitStatusID?.Value !== 40)
   
      if(ru.length) {
        setRelatedUnits(ru)
      }
    }
  }, [frontpageData, rawUnits, language])
  return (
    <div style={{ width: "100%" }}>
  
      <Header page="frontpage" {...homeData} />
      <HeaderDescription f_clr={f_clr} {...homeData} />
      {/* <Box
        sx={{
          padding: {
            xs: "40px 16px",
            sm: "40px 24px", // tablet exact padding
            md: "64px 80px",
          },
        }}
      >
        <RightLeftDescription page="frontpage" {...homeData} />
      </Box> */}
       <Box
      sx={{
        padding: {
          xs: "40px 16px", // mobile
          sm: "40px 24px", // tablets & small desktops
        },
        ...(isLargeDesktop && {
          padding: "64px 24px", // only for >= 1330px
        }),
      }}
    >
      <RightLeftDescription page="frontpage" {...homeData} />
    </Box>
      {/* <PropertySlider {...homeData} /> */}
        {
        Boolean(relatedUnits?.length) && <Box sx={{ pt: { xs: "20px", lg:'31.5px' }, pb: { xs: "20px", lg:'32px' } }} >
          <RelatedUnits relatedUnits={relatedUnits} />
        </Box>
      }
      <MainFooter />
    </div>
  );
};
